module.exports = __webpack_public_path__ + "images/emoji/heavy_division_sign.c77c54ce6fd6e4e9ce07.png";